import { Box, Grid } from '@material-ui/core'
import { useEffect, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchUnits } from '../../../redux/actions/unitsActions';
import { AppStateType } from '../../../redux/reducers';
import { UnitsContext } from '../../../components/contexts/UnitsContext';
import { urls, useRouting } from '../../../routes';
import { useParams, useRouteMatch } from 'react-router-dom';
import { UnitForm } from './unit-form/UnitForm';
import { RenderFacilities } from './RenderFacilities';
import { InfoCard } from '../../../components/FacilityInfoCard';
import {fetchCompany} from "../../../redux/actions/companyActions";

export const EditFacility = () => {
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch()
    const { url } = useRouteMatch();
    const { routeTo } = useRouting();
    const { existingUnitState, chosenUnitState, currentUnitState } = useContext(UnitsContext)
    const property = useSelector((state: AppStateType) => state.propertyReducer.property)!
    const user = useSelector((state: AppStateType) => state.authReducer.user)!
    const facilities = useSelector((state: AppStateType) => state.facilitiesReducer.facilities);
    const a11yStandardValues = useSelector((state: AppStateType) => state.a11yStandardReducer.a11yStandard)

    const [currentUnit, setCurrentUnit] = currentUnitState
    const [existingUnit, setExistingUnit] = existingUnitState
    const [, setChosenUnit] = chosenUnitState

    const a11yStandard = a11yStandardValues.find((item) => {
        return item.key === property.a11y_standard
    });

    useEffect(() => {
        if (property) {
            dispatch(fetchUnits(property.id, user.token))
            dispatch(fetchCompany(property.company, user.token))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (url.includes('edit-facilities') && (!facilities || facilities.length < 1)) {
            routeTo(urls.selectFacilities, { id: property ? property.id : id })
        }
    }, [])

    const getDefaultItem = () => {
        return {
            type: facilities?.length > 0 ? facilities[0] : '',
            property: property ? property.id : id,
        }
    }

    return (
        <Box style={{ padding: '0px 15px 80px', height: "100%", overflowX: "visible" }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4} lg={3}>
                    <Box bgcolor={'#233245'}>
                        <RenderFacilities
                            property={property}
                            setCurrentUnit={setCurrentUnit}
                            setExistingUnit={setExistingUnit}
                            setChosenUnit={setChosenUnit}
                            a11yStandard={a11yStandard}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} md={8} lg={7}>
                    <UnitForm
                        currentUnit={currentUnit ?? getDefaultItem()}
                        existingUnit={existingUnit}
                        setExistingUnit={setExistingUnit}
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={2}>
                    <InfoCard />
                </Grid>
            </Grid>
        </Box>
    )
}
